module.exports = __webpack_public_path__ + "img/booth-base.59b50c0c.png";